import callApi from '../../util/apiCaller';
import { getFileUrl } from '../../util/file';
import { slugify } from '../../util/text';
import { enabledLanguages } from '../../../Intl/setup';

import { getTranslation, initLanguage, getLanguagePath } from '../Intl/IntlActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT_PICTURES = 'SET_PRODUCT_PICTURES';

// Export Actions

export function getProductsRequest() {
    return dispatch => {
        return callApi('products').then(res => {
            if(res.products) {
                dispatch(setProducts(res.products));
                // res.products.forEach(product => {
                //     getProductPicturesRequest(product.pictures, picturesUrl => {
                //         dispatch(setProductPictures(product._id, picturesUrl));
                //     });
                // });
            }
            return res.products;
        }).catch(error => {
            dispatch(addError(error));
        });
    };
}

export function editProductRequest(product) {
    return dispatch => {
        return callApi('product/edit', 'post', { product }).then(res => {
            if(res.product) {
                dispatch(getProductsRequest());
                return res.product;
            }
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// export function setLocaleFromProduct(store, productSlug) {
//     return dispatch => {
//         return new Promise((resolve, reject) => {
//             return enabledLanguages.some(lang => {
//                 const product = getProductBySlug(store, productSlug, lang);
//                 if(product) {
//                     // console.log(productSlug, product.slug, getTranslation(product, 'slug', lang), getProductSlug(product, lang));
//                     // EN => default language for name, slug, ...
//                     if(getProductSlug(product, lang) === productSlug) {
//                         dispatch(initLanguage(lang));
//                         resolve(lang);
//                         return true;
//                     }
//                     resolve();
//                     return false;
//                 }
//                 resolve();
//                 return false;
//             });
//         });
//     };
// }

// export function getProductPicturesRequest(pictures, callbackSuccess, picturesUrl = [], index = 0) {
//     const picture = pictures[index];
//     if(picture) {
//         getFileUrl(picture).then(url => {
//             picturesUrl[index] = url;
//             getProductPicturesRequest(pictures, callbackSuccess, picturesUrl, index + 1);
//         });
//     } else {
//         callbackSuccess(picturesUrl);
//     }
// }

// Getters
export function getProducts(store, isActive = null) {
    let products = store.products.data;
    if(isActive !== null) {
        products = products.filter(product => product.isActive === isActive);
    }
    return products;
}

export function getMainProduct(store) {
    const products = getProducts(store, true);
    if(products.length) {
        if(products.length === 1) {
            return products[0];
        }
        return products.find(product => getProductOption(product, 'isMainProduct'));
    }
    return null;
}

export function getProduct(store, productId) {
    return store.products.data.find(product => product._id === productId);
}

export function getProductCompanyId(product) {
    return product.company && product.company._id ? product.company._id : product.company;
}

export function getProductBySlug(store, productSlug, lang = null) {
    return store.products.data.find(product => {
        return getProductSlug(product, lang || store.intl.locale) === (productSlug && productSlug.toLowerCase());
    });
}

export function getProductSlug(product, lang) {
    const slug = getTranslation(product, 'slug', lang);
    const name = getTranslation(product, 'name', lang);
    return slug ? slug.toLowerCase() : slugify(name).toLowerCase();
}

export function getProductSlugPath(product, lang) {
    return getLanguagePath(`/${getProductSlug(product, lang)}`, lang);
}

export function getProductsAttributeList(store, attributeName, lang = null) {
    let attributes = [];
    getProducts(store).forEach(product => {
        const productAttributes = getProductAttributeList(product, attributeName, lang || store.intl.locale);
        if(productAttributes) {
            attributes = attributes.concat(productAttributes);
        }
    });
    return attributes.filter((attribute, index, self) => self.indexOf(attribute) === index) || [];
}

export function getProductAttributeList(product, attributeName, lang) {
    return getTranslation(product, attributeName, lang) || [];
}

export function getProductOption(product, key) {
    return (product && product.options && product.options[key]) || '';
}

export function getProductMatchingPack(product, quantity) {
    return product && (product.packs || []).sort((packA, packB) => packB.quantity - packA.quantity).find(pack => quantity >= pack.quantity);
}

export function getProductPrice(product, quantity = 1) {
    if(product) {
        const matchingPack = getProductMatchingPack(product, quantity);
        if(matchingPack) {
            return parseFloat(matchingPack.unitPriceHT) * quantity;
        }
        return parseFloat(product.priceHT) * quantity;
    }
    return 0;
}

export function setProducts(products) {
    return {
        type: SET_PRODUCTS,
        products,
    };
}

export function setProductPictures(productId, picturesUrl) {
    return {
        type: SET_PRODUCT_PICTURES,
        productId,
        picturesUrl,
    };
}
